import "./index.scss";

interface PulseIndicatorProps {
  color?: "red" | "green" | "blue" | "orange";
  size?: "small" | "medium" | "large";
}

const PulseIndicator = ({
  color = "red",
  size = "medium",
}: PulseIndicatorProps) => {
  return (
    <span
      className={`pulse-indicator pulse-indicator--${color} pulse-indicator--${size}`}
    />
  );
};

export default PulseIndicator;

